import { render, staticRenderFns } from "./invoiceAdd.vue?vue&type=template&id=795807ef&scoped=true"
import script from "./invoiceAdd.vue?vue&type=script&lang=js"
export * from "./invoiceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795807ef",
  null
  
)

export default component.exports